import { render, staticRenderFns } from "./RoleChip.vue?vue&type=template&id=5bb3fa9e&"
import script from "./RoleChip.vue?vue&type=script&lang=js&"
export * from "./RoleChip.vue?vue&type=script&lang=js&"
import style0 from "./RoleChip.vue?vue&type=style&index=0&id=5bb3fa9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports